// src/modules/app-views/omnichannel/pages/Init/components/WhatsAppSourceTag.jsx
// *******************************************************************************
// WHATSAPP SOURCE TAG — reusable tag for Meta / Unofficial source type
// *******************************************************************************

import { Tag } from 'antd';
import { WhatsAppOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// COMPONENT
// *******************************************************************************

const WhatsAppSourceTag = ({ sourceType, size = 'default', style }) => {
  const isMeta = sourceType === 'meta';
  const isSmall = size === 'small';

  return (
    <Tag
      // color={isMeta ? 'green' : '#FF9800'}
      color={isMeta ? '#0966FF' : '#FF9800'}
      style={{
        fontSize: isSmall ? 10 : 11,
        lineHeight: isSmall ? '16px' : '18px',
        padding: isSmall ? '0 4px' : '0 6px',
        margin: 0,
        flexShrink: 0,
        ...style,
      }}
    >
      <WhatsAppOutlined style={{ marginRight: isSmall ? 3 : 4, color: '#25D366' }} />
      {isMeta ? 'META' : translateX('unofficial').toUpperCase()}
    </Tag>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default WhatsAppSourceTag;
